<template>
  <el-upload
    ref="upload"
    :before-upload="beforeUpload"
    class="avatar-uploader"
    action="default"
    :disabled="status === 'pending' || status === 'approved' || (status === 'refuse' && fileList.length !== 0 && !deleteable)"
    :http-request="upload"
    :headers="uploadHeaders"
    :show-file-list="false"
    :list-type="type==='img'?'picture':'text'"
    :file-list="fileList"
    :before-remove='remove'
    :on-success="handleAvatarSuccess"
    :on-error="uploadError"
  >
    <div class="upload-bt ">上传</div>
    <div
      v-if="complete>0 && complete<100"
      style="display: flex; align-items: center"
    >
      <el-progress
        style="flex: 1"
        :percentage="complete"
        color="#f56c6c"
        :text-inside="true"
      ></el-progress>
      <img
        src="@/assets/images/icon_close.png"
        style="width: 8px; height: 8px; margin-left: 3px"
        @click.stop="removeFile"
      />
    </div>
  </el-upload>
</template>

<script>
import axios from 'axios'
import { uploadFile } from '../service/contestantInfo.js'
import eventBus from './events'
import { event } from '../main'
import { descriptionIsVideo, descriptionIsRethink } from '../model/processingData'
import auditStatus from '@/model/auditStatus'
export default {
  name: 'uploadImage',
  props: ['tag', 'type', 'img', 'index', 'name', 'path', 'activityId', 'playerId', 'fileDesc', 'deleteable'],
  data () {
    return {
      complete: 0,
      uploadHeaders: {
        'Authentication-Token': localStorage.getItem('auth_token')
      },
      fileList: [],
      fileSize: 0,
      fileStatusText: '被驳回',
      uploading: false,
      cancelToken: ''
    }
  },
  computed: {
    status () {
      return this.$store.getters.getMaterialsStatus
    }
  },
  watch: {
    'name': {
      immediate: true,
      handler: function () {
        if (this.name) {
          let obj = {}
          if (this.type === 'pdf') {
            obj.url = this.path
            obj.name = this.name
          } else {
            obj.url = this.path.url
            obj.name = this.name
          }
          this.fileList = [obj]
        }
      },
      deep: true
    },
    fileDesc (val) {
      this.desc = val
    },
    deleteable (val) {
      this.desc = val
    }
  },
  created () {
    if (!this.name) {
      event.$on('clearUploadList', () => {
        this.$refs['upload'].clearFiles()
      })
    }
  },
  mounted () {
    eventBus.$on('removeFile', (tag) => {
      if (this.tag === tag) {
        this.remove()
      }
    })
  },
  methods: {
    uploadError () {
      this.uploading = false
    },
    removeFile () {
      this.complete = 0
      this.cancelToken.cancel('cancel-manual')
      this.$refs.upload.clearFiles()
      this.uploading = false
    },
    // 覆盖默认上传行为
    upload (item) {
      this.uploading = true
      this.fileSize = item.file.size
      let params = {}
      params.upload_type = 'material'
      params.activity_id = String(this.activityId)
      params.player_id = String(this.playerId)
      uploadFile(params).then(res => {
        this.host = res.data.host
        let params = {
          host: res.data.host
        }
        let fd = new FormData()
        fd.append('callback', res.data.callback)
        fd.append('success_action_status', '200')
        fd.append('OSSAccessKeyId', res.data.accessid)
        fd.append('policy', res.data.policy)
        fd.append('signature', res.data.signature)
        fd.append('key', `${res.data.dir}${item.file.name}`)
        fd.append('host', this.host)
        fd.append('x:activity_id', String(this.activityId))
        fd.append('x:user_id', String(this.playerId))
        fd.append('file', item.file)
        fd.append('expire', res.data.expire)
        fd.append('name', `${item.file.name}`)
        params['fd'] = fd
        this.complete = 0
        this.cancelToken = axios.CancelToken.source()
        axios.post(params.host, params.fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          cancelToken: this.cancelToken.token,
          onUploadProgress: progressEvent => {
            let complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
            this.complete = complete
            self.uploadMessage = '上传 ' + complete
          }
        }).then((res2) => {
          if (res2.data.status === 'OK') {
            this.res = res2.data.filename
            this.handleAvatarSuccess('res', item, [item], this.tag)
            this.fileStatusText = '已更新'
          } else {
            this.uploading = false
            this.$confirm(`上传失败`, '提示')
          }
        }).catch((error) => {
          this.uploading = false
          if (!error || error.message !== 'cancel-manual') {
            this.$confirm(`上传失败`, '提示')
          }
        })
      })
        .catch(() => {
          this.uploading = false
          this.$confirm(`上传失败`, '提示')
        })
    },
    verify (type, file, reg) {
      // 验证
      if (!reg.test(file.name)) {
        this.$confirm(`请选择${type}文件格式`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return false
      }
    },
    uploadGetIndex (e) {
      this.index = e
    },
    beforeUpload (file) {
      if (this.uploading) {
        this.$alert('文件正在上传中，请勿重复上传。如需更换文件，请待本次上传完成后，点击删除并重新上传。', '温馨提示', { confirmButtonText: '知道了', dangerouslyUseHTMLString: true })
        return false
      }
      // 上传之前做后缀验证
      if (this.fileDesc && descriptionIsRethink(this.fileDesc)) { // 教学反思文件格式
        console.log('教学反思文件格式')
        let reg = /(?:.doc|.docx)$/
        return this.verify('Word', file, reg)
      }
      // 这里会先对desc进行判断，如果包含视频特定字符串则为视频格式，即使prop中传入的是mp4也是没有问题的。
      if (this.fileDesc && descriptionIsVideo(this.fileDesc)) { // 教学视频文件格式
        console.log('教学视频文件格式')
        let reg = /(?:.avi|.m4v|.mkv|.flv|.vob|.mp4|.3gp|.rm|.rmvb|.wmv|.asf|.asx|.MP4|.mpg|.mpeg|.mov)$/
        return this.verify('视频', file, reg)
      }
      if (this.type === 'pdf') {
        let reg = /(?:.pdf)$/
        return this.verify('pdf', file, reg)
      }
      if (this.type === 'ppt') {
        let reg = /(?:.ppt|.pptx)$/
        return this.verify('ppt', file, reg)
      }
      if (this.type === 'word') {
        let reg = /(?:.doc|.docx)$/
        return this.verify('Word', file, reg)
      }
      if (this.type === 'zip') {
        let reg = /(?:.zip)$/
        return this.verify('zip', file, reg)
      }
    },
    remove () {
      this.fileList.pop()
      // 这里使用的是PersonInfo中的this.status
      let verifyStatus = this.$store.getters.getMaterialsStatus
      if (verifyStatus === auditStatus.PENDING) {
        this.$alert('信息审核中，请勿删除文件', '消息提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return false
      }
      if (verifyStatus === auditStatus.APPROVED) {
        this.$alert('信息已通过，不可删除文件', '消息提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return false
      }
      // this.$emit('uploadDel')
    },
    handleAvatarSuccess (res, file, fileList, tag) {
      this.uploading = false
      file.name = file.file.name
      file.index = fileList[0].index
      this.fileList = [file]
      this.$emit('uploadSucc', this.res, file.name, this.host, this.fileSize, tag)
    }
  }
}
</script>
<style lang="scss" scoped>
.file-icon {
  width: 106px;
  height: auto;
  vertical-align: bottom;
}
.del-btn {
  position: absolute;
  bottom: 0;
  width: 50px;
  text-align: center;
  height: 20px;
  left: 27px;
  line-height: 3px;
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: #e34221;
  background: #fff;
  background: rgba(251, 236, 236, 1);
  border-radius: 0px 2px 0px 2px;
}
.del-left-btn {
  left: 0px;
}
.avatar-uploader {
  width: 50px;
  /deep/ .el-upload-list__item-status-label {
    right: 0;
  }
  /deep/ .el-upload-list__item-name {
    margin-right: 15px;
  }
}
.refused {
  position: absolute;
  top: 5px;
  right: 13px;
  height: 15px;
  line-height: 15px;
  padding: 1px 7px;
  font-size: 9px;
  color: #ffffff;
  border-radius: 8px;
}
.red-bg {
  background: rgba(231, 86, 86, 1);
}
.blue-bg {
  background: rgba(81, 83, 133, 1);
}
.upload-bt {
  width: 50px;
  line-height: 20px;
  font-size: 12px;
  color: #717171;
  background: linear-gradient(
    180deg,
    rgba(246, 246, 246, 1) 0%,
    rgba(236, 236, 236, 1) 100%
  );
  border-radius: 3px;
  border: 1px solid rgba(153, 153, 153, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/MaterialUploadBt.vue